import { MESSAGE_NOTIFICATION } from "../gig/chat/duck/types";
import { PLACEHOLDER_DATA, PROGRAM_LIST, UNIVERSITY_LIST } from "./constants";
import RandomUsers from "./randomUsers.json";

export const getAllOrders = () => {
  const allURLS = [];
  let i = 0;
  const universityList = Object.values(UNIVERSITY_LIST);
  allURLS.push(
    ...universityList.map((_) => {
      const obj = PLACEHOLDER_DATA["life-at-campus"](_);
      return {
        ...obj,
        _id: `life-at-campus/${_.toLowerCase().replaceAll(" ", "-")}`,
        requestee: {
          ...obj.requestee,
          ...RandomUsers[i++],
        },
        category: "life-at-campus",
      };
    })
  );
  const programList = Object.values(PROGRAM_LIST);
  allURLS.push(
    ...programList.map((_) => {
      const obj = PLACEHOLDER_DATA["university-shortlisting"](_);
      return {
        ...obj,
        _id: `university-shortlisting/${_.toLowerCase().replaceAll(" ", "-")}`,
        requestee: {
          ...obj.requestee,
          ...RandomUsers[i++],
        },
        category: "university-shortlisting",
      };
    })
  );

  Object.keys(PLACEHOLDER_DATA)
    .filter((_) => !["life-at-campus", "university-shortlisting"].includes(_))
    .map((_key) => {
      universityList.map((_university) => {
        programList.map((_program) => {
          const _obj = PLACEHOLDER_DATA[_key](_university, _program);
          allURLS.push({
            ..._obj,
            _id: `${_key}/${_university
              .toLowerCase()
              .replaceAll(" ", "-")}/${_program
              .toLowerCase()
              .replaceAll(" ", "-")}`,
            requestee: {
              ..._obj.requestee,
              ...RandomUsers[i++],
            },
            category: _key,
          });
          return null;
        });
        return null;
      });
      return null;
    });

  return allURLS;
};

export const recommendOrders = (limit = 4) => {
  const allURLS = getAllOrders();
  return allURLS
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value)
    .slice(0, limit);
};

export const getData = ({
  orderSlug,
  university,
  program,
  onError,
  locationPath,
}) => {
  let data = {};
  if (locationPath) {
    const allData = getAllOrders();
    data = allData.filter((_) => _?._id === locationPath)?.[0];
    if (!data) {
      if (typeof onError === "function") {
        onError();
      }
    }
  } else {
    if (orderSlug === "life-at-campus") {
      data = PLACEHOLDER_DATA[orderSlug](UNIVERSITY_LIST[university]);
    } else if (orderSlug === "university-shortlisting") {
      data = PLACEHOLDER_DATA[orderSlug](PROGRAM_LIST[university]);
    } else if (!university?.length || !program?.length) {
      if (typeof onError === "function") {
        onError();
      }
    } else {
      data = PLACEHOLDER_DATA[orderSlug](
        UNIVERSITY_LIST[university],
        PROGRAM_LIST[program]
      );
    }
  }

  return data;
};

export const wrap = (min, max, v) => {
  const rangeSize = max - min;
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

export const getAutomatedMessages = (loggedInUserFirstName, link, title) =>
  title?.length && link?.length
    ? [
        {
          attachment: {
            [MESSAGE_NOTIFICATION]: {
              link: {
                src: link,
                text: `New Thread: ${title}`,
              },
            },
          },
          textMessage: "",
        },
        {
          textMessage: `Congratulations ${loggedInUserFirstName} 🎉, thank you for choosing to become a Nbyula Mentor.\n\nI am Anika from the Marketplace team and I will assist you to get started. To begin with, I would like to know the following from you:\n\n1. Your working timezone 🌎 (so that mentees don't wake you up :)\n2. Approx hours per week you'd be available for mentorship ⏰\n3. Preferable format of mentorship; Chat 💬, Video Meeting 📷, or Both\n4. Preferable mode of payout settlement; PayPal or Direct Bank Transfer 💰\n\nFor any queries, feel free to ask in this chat room.`,
        },
      ]
    : [];
